module.exports = __webpack_public_path__ + "img/3M7A2089n.ab778b58.png";